type AgeGroupCount = {
  ageGroup: string;
  count: number;
};

function normalizeAgeGroup(value: string): string {
  return value.trim().toUpperCase();
}

export function pickDefaultSplitAgeGroup(
  ageGroups: string[],
  countsByAgeGroup: AgeGroupCount[],
): string {
  if (ageGroups.length === 0) {
    return "";
  }

  const keyToOriginal = new Map<string, string>();
  for (const ageGroup of ageGroups) {
    const normalized = normalizeAgeGroup(ageGroup);
    if (!normalized) continue;
    keyToOriginal.set(normalized, ageGroup);
  }

  const counts = new Map<string, number>();
  for (const row of countsByAgeGroup) {
    const normalized = normalizeAgeGroup(row.ageGroup);
    if (!normalized) continue;
    counts.set(normalized, (counts.get(normalized) ?? 0) + Math.max(0, row.count));
  }

  const hasPeople = (normalizedAgeGroup: string): boolean =>
    (counts.get(normalizedAgeGroup) ?? 0) > 0;

  const preferredWithPeople = ["MPRO", "M30-34"] as const;
  for (const preferred of preferredWithPeople) {
    const value = keyToOriginal.get(preferred);
    if (value && hasPeople(preferred)) {
      return value;
    }
  }

  let largestGroupKey = "";
  let largestGroupCount = 0;
  for (const normalizedAgeGroup of keyToOriginal.keys()) {
    const count = counts.get(normalizedAgeGroup) ?? 0;
    if (count > largestGroupCount) {
      largestGroupCount = count;
      largestGroupKey = normalizedAgeGroup;
    }
  }
  if (largestGroupKey) {
    return keyToOriginal.get(largestGroupKey) ?? "";
  }

  const preferredFallback = ["MPRO", "M30-34"] as const;
  for (const preferred of preferredFallback) {
    const value = keyToOriginal.get(preferred);
    if (value) {
      return value;
    }
  }

  return ageGroups[0] ?? "";
}
